const {
  REACT_APP_DEFAULT_EMAIL = "",
  REACT_APP_DEFAULT_PASSWORD = "",
  REACT_APP_ENV,
  REACT_APP_API_URL,
  REACT_APP_API_NEW,
  REACT_APP_FIREBASE_DYNAMIC_LINK_URL,
  REACT_APP_API_TRANSLATION,
} = process.env;

const apiUrl = REACT_APP_API_URL;
export const apiMsUrl = REACT_APP_API_NEW;

const apiUrlNew = REACT_APP_API_NEW;
const translationsUrl =  REACT_APP_API_TRANSLATION;

const environmentName = REACT_APP_ENV;

export const isDevelopment = REACT_APP_ENV === "development";

export const isProduction = REACT_APP_ENV === "production";

export const isStaging = REACT_APP_ENV === "staging";

export const isTesting = REACT_APP_ENV === "test";

export const email = isDevelopment ? REACT_APP_DEFAULT_EMAIL : "";

export const password = isDevelopment ? REACT_APP_DEFAULT_PASSWORD : "";

export const firebaseDynamicLinkUrl = REACT_APP_FIREBASE_DYNAMIC_LINK_URL;

export { apiUrl, apiUrlNew, environmentName, translationsUrl };
